import { Component, createRef } from 'react'
import PropTypes from 'prop-types'

export default class Form extends Component {
  static propTypes = {
    action: PropTypes.string,
    method: PropTypes.string,
    onSubmit: PropTypes.func,
    className: PropTypes.string,
    acceptCharset: PropTypes.string,
    ignoreMissingSubmitHandler: PropTypes.bool.isRequired,
  }
  static defaultProps = {
    className: null,
    action: null,
    method: 'post',
    acceptCharset: 'UTF-8',
    onSubmit: null,
    ignoreMissingSubmitHandler: false,
  }

  constructor(props) {
    super(props)
    this.$formRef = createRef()
    this.checkMissingSubmitHandler()
  }

  handleSubmit = event => {
    const { onSubmit } = this.props
    if (onSubmit) {
      onSubmit(event)
    }
  }

  submit() {
    this.$formRef.current.submit()
  }

  checkMissingSubmitHandler() {
    const { action, onSubmit, ignoreMissingSubmitHandler } = this.props
    if (!onSubmit && !ignoreMissingSubmitHandler) {
      throw new Error(`A form component is missing onSubmit handler, it will submit to ${action} when hitting return.`)
    }
  }

  render() {
    const { action, method, onSubmit, className, acceptCharset, children } = this.props
    return (
      <form
        onSubmit={this.handleSubmit}
        className={className}
        acceptCharset={acceptCharset}
        action={action}
        method={method}
        ref={this.$formRef}
      >
        {children}
      </form>
    )
  }
}
